import { OPPORTUNITIES_MESSAGES_ELEMENTS } from '../../models/BusinessOpportunities/constants';
export const MESSAGES_ELEMENT_FIELDS = {
    [OPPORTUNITIES_MESSAGES_ELEMENTS.FEATURE_ANN]: {
        nextAppearance: 'opportunitiesFeatureAnnNextAppearance',
        dismissCount: 'opportunitiesFeatureAnnDismissCount',
    },
};
